import { Directive, Input, ElementRef, } from '@angular/core';
import { LyShadowService } from './shadow.service';
var LyDeepComponent = (function () {
    /**
     * @param {?} elementRef
     * @param {?} shadow
     */
    function LyDeepComponent(elementRef, shadow) {
        this.elementRef = elementRef;
        this.shadow = shadow;
        this._size = 1;
        this._interval = 3000;
        this.numberState = -1;
        this._color = 'rgba(0, 0, 0, 0.5)';
    }
    /**
     * @return {?}
     */
    LyDeepComponent.prototype.styleHost = function () {
        var /** @type {?} */ style = "rgba(0, 0, 0, " + ((60 / 100) * Number('0.' + String(this._size))) + ") 0px " + ((3 * this._size) - 2) / 3 * this.numberState + "px " + (3 * this._size * 2) + "px 0px" + ',' + " rgba(0, 0, 0, " + (40 / 100) * Number('0.' + String(this._size)) + ") 0px " + (((3 * this._size) - 2)) * this.numberState + "px " + (3 * this._size * 2) / 2 + "px 0px";
        if (this._size < 2 && this._size > 0) {
            style = style + (", rgba(0, 0, 0, 0.12) 0px " + 2 * this.numberState + "px 6px 0px");
        }
        // this.elementRef.nativeElement.style.boxShadow = style;
        this.elementRef.nativeElement.style.boxShadow = this.shadow.shadow(this._color, this._size);
    };
    Object.defineProperty(LyDeepComponent.prototype, "scale", {
        /**
         * @return {?}
         */
        get: function () {
            return this._size;
        },
        /**
         * @param {?} val
         * @return {?}
         */
        set: function (val) {
            this._size = val;
            // this.numberState = val >= 0 ? 1 : -1;
            // if (this.numberState === -1) {
            //   this._size = val * -1;
            // } else {
            //   this._size = val;
            // }
            this.styleHost();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyDeepComponent.prototype, "color", {
        /**
         * @param {?} val
         * @return {?}
         */
        set: function (val) {
            this._color = val;
            this.styleHost();
        },
        enumerable: true,
        configurable: true
    });
    return LyDeepComponent;
}());
export { LyDeepComponent };
LyDeepComponent.decorators = [
    { type: Directive, args: [{
                //.toString(),
                selector: '[ly-deep], [ly-shadow], ly-shadow',
            },] },
];
/**
 * @nocollapse
 */
LyDeepComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: LyShadowService, },
]; };
LyDeepComponent.propDecorators = {
    'scale': [{ type: Input },],
    'color': [{ type: Input },],
};
function LyDeepComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    LyDeepComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    LyDeepComponent.ctorParameters;
    /** @type {?} */
    LyDeepComponent.propDecorators;
    /** @type {?} */
    LyDeepComponent.prototype._size;
    /** @type {?} */
    LyDeepComponent.prototype._interval;
    /** @type {?} */
    LyDeepComponent.prototype._result;
    /** @type {?} */
    LyDeepComponent.prototype.numberState;
    /** @type {?} */
    LyDeepComponent.prototype._color;
    /** @type {?} */
    LyDeepComponent.prototype.elementRef;
    /** @type {?} */
    LyDeepComponent.prototype.shadow;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/shadow/deep.js
// module id = 698
// module chunks = 31